import { Component, Input, EventEmitter, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { IOrganization } from '../../../types/contactModule';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { replaceUnderscores } from '../../../../utils/utils';
import { GroupPickerComponent } from '../../organization/contacts/group-picker/group-picker.component';

/** Picks organizations for a contact form; the form saves them with the contact. */
@Component({
  selector: 'assign-organizations-modal',
  standalone: true,
  imports: [ModalFormContainerComponent, GroupPickerComponent],
  templateUrl: './assign-organizations-modal.component.html',
  styleUrls: [
    '../../organization/contacts/group-picker/group-modal.css',
    './assign-organizations-modal.component.css',
  ],
})
export class AssignOrganizationsTableComponent implements OnChanges {
  replacer = replaceUnderscores;

  @Input() open: boolean = false;
  @Input() selection: IOrganization[] = [];
  @Output() close = new EventEmitter();
  @Output() updateSelection = new EventEmitter<IOrganization[]>();

  // services
  contactService = inject(ContactsService);

  selectedOrganizations: IOrganization[] = [];

  onPick(items: any[]) {
    this.selectedOrganizations = items as IOrganization[];
  }

  emitSelection() {
    this.updateSelection.emit([...this.selectedOrganizations]);
    this.closeModal();
  }

  closeModal() {
    this.close.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] || changes['selection']) {
      this.selectedOrganizations = [...(this.selection ?? [])];
    }
  }
}
